import type { TourConfig } from 'tio-common/services/tour-manager';

const advancedFiltersMovedTour: TourConfig = {
  id: 'advanced-filters-moved',
  name: 'Advanced Filters Location',
  steps: [
    {
      element: '[data-tour="advanced-filters-button"]',
      popover: {
        title: 'Advanced Filters Moved',
        description:
          'The Advanced Filters have moved to this new location in the sidebar. Click here to access all your filtering and column options.',
        side: 'left',
        align: 'start',
      },
    },
  ],
  driverOptions: {
    showProgress: false,
    showButtons: ['close'],
  },
};

export { advancedFiltersMovedTour };
